import { AppTeamUtil } from '../../core/app-team-util';

export class RegisteredUsersDailyInfo
{
	Date!: Date;
	ActionCount!: number;

	constructor(json?: any)
	{
		this.Date = AppTeamUtil.convertApiDateStringToDate(json['Date'])!;
		this.ActionCount = json.ActionCount;
	}
}

export class RegisteredUsersReportData
{
	DailyInfo!: RegisteredUsersDailyInfo[];
	UniqueUserCount!: number;

	constructor(json?: any)
	{
		this.UniqueUserCount = json.UniqueUserCount;
		this.DailyInfo = json.DailyInfo.map((itemJson: any) => new RegisteredUsersDailyInfo(itemJson));
	}
}
